import React, { Fragment } from 'react';
import './Footer.scss';
import icon1 from './icon-label.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import {API} from '../../services/api';

const Footer = () => {
    /**
     * Componente Footer
     * Es el pie de pagina de la aplicación
     * Carga las visitas del sitio web
     */

    const [visitorsCount, setVisitorsCounter] = useState(0);

    useEffect(() => {
        /**
         * Obtener cantidad de visitas
         * Se hace el llamado al servicio /visits/count
         */
        API.getVisitsCount()
            .then(x => {
                setVisitorsCounter(x.count);
            })
    }, [])

    return (
        <Fragment>
            <div className="footerMainContainer">
                <div className="item0_Contact">
                    <span >Servicio Nacional de Pesca y Acuicultura</span>
                    <span >Victoria 2832, Valparaíso, Chile</span>
                    <span >Fono 800 320 032</span>
                </div>

                <div className="item1_ListUrls">
                    <div className="item" onClick={() => { window.open(' http://www.sernapesca.cl/area-trabajo/acuicultura/preguntas-frecuentes', '_blank') }}>Preguntas frecuentes</div>
                    <div className="item" onClick={() => { window.open('http://www.sernapesca.cl/sistema-integral-de-informacion-y-atencion-ciudadana-siac', '_blank') }}>Contacto</div>
                    <div className="item" onClick={() => { window.open('http://www.sernapesca.cl/politicas-de-privacidad', '_blank') }}>Políticas de privacidad</div>
                    <div className="item" onClick={() => { window.open('http://www.sernapesca.cl/seguridad-de-la-informacion', '_blank') }}>Seguridad de la información</div>
                </div>

                <div className="item2_VisitCounter">
                    <span className="label">Visitas</span>
                    <span className="labelBold">{visitorsCount}</span>
                </div>

                <div className="item3_BorderColors">
                    <img className="colors" src={icon1} alt="" />
                </div>

                <div className="item4_Logo">
                    {/* <img onClick={() => { window.open("https://web.shellcatch.com/welcome", "_blank") }} src={logoShellcatch} alt="Logo frescapesca"></img> */}
                </div>
            </div>
        </Fragment>
    )
}

export default Footer;